import React from 'react';
import { Modal } from 'react-bootstrap';
import { CreateCarForm } from 'Containers';
import { translate } from 'Hoc';

const CreateCarModal = ({ t, ...modalProps }) => (
  <Modal {...modalProps}>
    <Modal.Header closeButton>
      <Modal.Title>{t('modalTitle')}</Modal.Title>
    </Modal.Header>
    <Modal.Body as={CreateCarForm} onCompleted={modalProps.onExit} />
  </Modal>
);

export default translate('create_car_form')(CreateCarModal);
